var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.875V7.49996C14.25 4.67157 14.2499 3.25733 13.3713 2.37865C12.4926 1.5 11.0784 1.5 8.24996 1.5C5.42162 1.5 4.0074 1.50005 3.12872 2.37869C2.25007 3.25736 2.25005 4.67154 2.25003 7.49991L2.25 10.875C2.24998 13.3405 2.24997 14.5734 2.93091 15.4031C3.05559 15.5551 3.1949 15.6943 3.34682 15.8191C4.17658 16.5 5.40937 16.5 7.87496 16.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25H11.25M5.25 8.25H8.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.875L12.375 13.4625V11.625M9 13.125C9 14.989 10.511 16.5 12.375 16.5C14.239 16.5 15.75 14.989 15.75 13.125C15.75 11.261 14.239 9.75 12.375 9.75C10.511 9.75 9 11.261 9 13.125Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadHistory);
export default __webpack_public_path__ + "static/media/lead-history.82b7e036041dd1f6eb54dbfddd76a619.svg";
export { ForwardRef as ReactComponent };